import {
  RECEIVE_DATA,
  REQUEST_DATA,
  RESET_STATE,
} from './DebtManagementChartActions';
import chartSettings from './DebtManagementChartSettings';

export const CHART_DATA = {
  Categories: [],
  Series: {
    Recommended: [],
    Current: [],
  },
  YearsToPayOff: null,
  IsNeverPaidOff: null,
};

export const CLIENT_STATE = {
  chartSettings,
  currentGoalId: '',
  data: CHART_DATA,
  fpId: '',
  goalId: '',
  isPdf: false,
  isPrint: false,
  loaded: false,
};

const INITIAL_STATE = {};

const debtManagement = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case REQUEST_DATA: {
      return {
        ...state,
        [action.clientId]: {
          ...CLIENT_STATE,
          ...state[action.clientId],
          loaded: false,
          data: CHART_DATA,
        },
      };
    }

    case RECEIVE_DATA: {
      return {
        ...state,
        [action.clientId]: {
          ...CLIENT_STATE,
          ...state[action.clientId],
          goalId: action.goalId,
          currentGoalId: action.goalId,
          loaded: true,
          data: action.data,
        },
      };
    }
    case RESET_STATE: {
      return INITIAL_STATE;
    }
    default:
      return state;
  }
};

export default debtManagement;
